import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewTestHistoryComp from "./Component/ViewTestHistoryComp"

const ViewTestHistory =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
             <ViewTestHistoryComp/>
        </div>
        <Footer />
        </>
    )
}

export default ViewTestHistory